import { FC } from 'react';

import styles from 'shared/SplashScreen/SplashScreen.scss';

const SplashScreen: FC = ({ children }) => <div className={styles.root}>{children}</div>;

export default SplashScreen;
